import React from "react";

const StockHeatMap = () => {
  return (
    <div>
      <iframe
        style={{ width: "100vw", height: "100vh" }}
        src="https://www.tradingview.com/heatmap/stock/#%7B%22dataSource%22%3A%22SPX500%22%2C%22blockColor%22%3A%22change%22%2C%22blockSize%22%3A%22market_cap_basic%22%2C%22grouping%22%3A%22sector%22%7D"
        title="Full Page"
      ></iframe>
    </div>
  );
};

export default StockHeatMap;
